webpackJsonp([107818501498521],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  return _react2.default.createElement(
	    "div",
	    { className: "blog-post" },
	    _react2.default.createElement(
	      "h1",
	      null,
	      post.frontmatter.title
	    ),
	    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: post.html } })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-afe3cdbc305ddbdeae28.js